import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

type Breakpoint = keyof typeof breakpointsTailwind

export default defineNuxtPlugin(() => {
   const br = useBreakpoints(breakpointsTailwind)
   const names = Object.keys(breakpointsTailwind) as Breakpoint[]

   const toMap = (build: (name: Breakpoint) => ComputedRef<boolean>) =>
      new Map(names.map((name): [Breakpoint, ComputedRef<boolean>] => [name, build(name)]))

   const greater = toMap((name) => br.greater(name))
   const smallerOrEqual = toMap((name) => br.smallerOrEqual(name))

   return {
      provide: {
         isBreakpoint: (breakpoint: Breakpoint, type: 'greater' | 'smaller'): boolean =>
            (type === 'greater'
               ? greater.get(breakpoint)?.value
               : smallerOrEqual.get(breakpoint)?.value) ?? false,
      },
   }
})
